// extracted by mini-css-extract-plugin
export default {"naviButton":"GRCarousel_naviButton__bv0dd","contentContainer":"GRCarousel_contentContainer__ciEe7"};